export const GIVE_NOW_SESSION_STORAGE_KEY = 'give_now';
